import React from "react";
import { Parser } from "json2csv";
import { Button } from '@mui/material'
import { format } from "date-fns";
import { useSnackbar } from "notistack";

const toReadableText = (value) => {
    if (value === null || value === undefined) return "";

    if (Array.isArray(value)) {
        return value
            .map((v) => (typeof v === "object" ? toReadableText(v) : String(v)))
            .join("; "); // แยกแต่ละ element ด้วย ;
    }

    if (typeof value === "object") {
        return Object.entries(value)
            .map(([k, v]) => `${k}: ${toReadableText(v)}`)
            .join(", "); // แต่ละ key-value แยกด้วย ,
    }

    return String(value);
};

// flatten object → convert nested object/array เป็น readable text
const flattenForCsv = (obj, parentKey = "", res = {}) => {
    for (let key in obj) {
        if (!Object.prototype.hasOwnProperty.call(obj, key)) continue;

        const newKey = parentKey ? `${parentKey}.${key}` : key;
        const value = obj[key];

        if (typeof value === "object" && value !== null) {
            res[newKey] = toReadableText(value); // แปลงเป็น text readable
        } else {
            res[newKey] = value;
        }
    }
    return res;
};

// preprocess JSON ก่อน export
const preprocessData = (jsonData) => {
    if (!jsonData) return [];

    const dataArray = Array.isArray(jsonData)
        ? jsonData
        : jsonData.data && Array.isArray(jsonData.data)
            ? jsonData.data
            : [jsonData];

    return dataArray.map((item) => flattenForCsv(item));
};


const DownLoadCsvExport = ({ jsonData, size = `small`, label = `Export CSV`, fileName = `export`, disabled = false }) => {
    const { enqueueSnackbar } = useSnackbar();
    const handleSnackbar = ({ variant, message }) => {
        enqueueSnackbar(message, { variant, autoHideDuration: 1500, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } });
    };
    const handleExport = () => {
        if (!jsonData) {
            handleSnackbar({ variant: "error", message: "ไม่มีข้อมูล" });
            // handleSnackbar({ variant: "success", message: "ไม่มีข้อมูล" });
            return;
        }

        try {
            const processedData = preprocessData(jsonData);
            if (processedData.length === 0) {
                alert("ไม่มีข้อมูลสำหรับ export");
                return;
            }
            const formatted = format(new Date(), "yyyy-MM-dd-HH-mm");

            const parser = new Parser();
            const csv = parser.parse(processedData);

            const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `${fileName}-${formatted}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        } catch (err) {
            console.error("CSV Export Error:", err);
        }
    };

    return <Button variant="outlined" size={size} disabled={disabled} onClick={handleExport}>{label}</Button>;
};

export default DownLoadCsvExport;
